var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKornik(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 321.784,
    height: 313.386,
    viewBox: "0 0 85.139 82.917",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "aria-label": "KO[]RNIK",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "22.5778px",
      lineHeight: 1.25,
      fontFamily: "'Agency FB'",
      InkscapeFontSpecification: "'Agency FB'",
      letterSpacing: "1.35996px",
      wordSpacing: 0,
      strokeWidth: 0.264583
    },
    transform: "translate(-35.105 -64.398)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.0878984,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.819786,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "6.55829,6.55829",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.183 113.96h-1.221l-2.881-7.655v7.655h-1.11V98.03h1.11v7.156l2.617-7.156h1.205v.091l-2.824 7.584zm7.337-1.13q0 .499-.256.814-.247.316-.638.316H61.13q-.39 0-.638-.316-.247-.315-.247-.814V99.16q0-.5.247-.815.247-.315.638-.315h3.496q.39 0 .638.315.255.316.255.815zm-1.11-.122V99.282h-3.056v13.426z",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "condensed",
      fontFamily: "'Agency FB'",
      InkscapeFontSpecification: "'Agency FB Condensed'",
      fill: "#2c5aa0",
      strokeWidth: 0.216305
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.54 113.96h-2.124q-.39 0-.638-.273-.247-.272-.247-.703V99.005q0-.43.247-.703.247-.272.638-.272h2.123v1.08h-1.9v13.769h1.9zm5.413-.976q0 .431-.256.703-.255.273-.646.273h-2.123v-1.081h1.915V99.11h-1.915v-1.08h2.123q.39 0 .646.272t.256.703z",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "condensed",
      fontFamily: "'Agency FB'",
      InkscapeFontSpecification: "'Agency FB Condensed'",
      fill: "#a00",
      strokeWidth: 0.200966
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.263 113.96h-1.165l-2.323-8.53.152-.285h1.98v-5.863h-2.85v14.678h-1.11V98.03h4.182q.392 0 .639.315.247.316.247.815v6.046q0 1.15-1.213 1.15-.12 0-.35-.01-.232-.02-.336-.02 1.077 3.806 2.147 7.634zm7.791 0h-.766l-3.336-11.716v11.716h-1.045V98.03h.83l3.272 11.512V98.03h1.045zm4.153 0h-1.11V98.03h1.11zm8.278 0h-1.221l-2.881-7.655v7.655h-1.11V98.03h1.11v7.156l2.618-7.156h1.205v.091l-2.825 7.584z",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "condensed",
      fontFamily: "'Agency FB'",
      InkscapeFontSpecification: "'Agency FB Condensed'",
      fill: "#2c5aa0",
      strokeWidth: 0.216305
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKornik);
export default __webpack_public_path__ + "static/media/kornik.108969fc9b5bcb0533fef26a77654198.svg";
export { ForwardRef as ReactComponent };